<template src="./Home.html"></template>
<style lang="scss" scoped src="./Home.scss"></style>

<script>
import Vue from "vue";
import Universes from "@/components/Home/Universes";
import BestSeller from "@/components/Home/BestSeller";
import LikedProduct from "@/components/Home/LikedProduct";
import {OrkReassurance} from "@/components/Ork";
import {OrkHomeGallery} from "@/components/Ork";

import Api from "@/api/Api";


export default Vue.extend({
  name: 'Home',
  components: {
    Universes,
    BestSeller,
    OrkHomeGallery,
    LikedProduct,
    OrkReassurance
  },
  data() {
    return {
      loading: true,
    }
  },
  created() {
    const descEl = document.querySelector('head meta[name="description"]');
    const titleEl = document.querySelector('head title');

    descEl.setAttribute('content', this.$i18n.t('seo.defaultDescription'));
    titleEl.textContent = this.$i18n.t('seo.defaultTitle');
    this.getHomeMarketing()
  },

  methods: {
    getHomeMarketing() {
      this.loading = true;
      Api.marketing.getHomeSeo().then((data) => {
        this.marketing = data;

        const descEl = document.querySelector('head meta[name="description"]');
        const titleEl = document.querySelector('head title');
        if (this.marketing.description)
          descEl.setAttribute('content', this.marketing.description);
        if (this.marketing.title)
          titleEl.textContent = this.marketing.title;
      }).catch((e) => {
      }).finally(this.loading = false)
    }
  }
});
</script>
